import { Skeleton } from '@/components/ui/skeleton'

interface SubgeoListItemSkeletonProps {
	count?: number
}

export const SubgeoListItemSkeleton = ({
	count = 5
}: SubgeoListItemSkeletonProps) => {
	return (
		<div className='flex flex-col gap-4 p-2.5'>
			{Array.from({ length: count }, (_, i) => `skeleton-${i}`).map(
				(key) => (
					<div className='flex items-center gap-2' key={key}>
						<Skeleton height={42} width={6} />
						<div className='flex w-full flex-col gap-1'>
							<Skeleton height={26} width={200} />
							<Skeleton height={12} width={100} />
						</div>
					</div>
				)
			)}
		</div>
	)
}

SubgeoListItemSkeleton.displayName = 'SubgeoListItemSkeleton'
